// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

   $w('#text277').onClick(() =>  {
        $w('#statebox13').changeState("state9")
    })

    $w('#text272').onClick(() =>  {
        $w('#statebox13').changeState("state10")
    })


    $w('#text282').onClick(() =>  {
        $w('#statebox14').changeState("state11")
    })

    $w('#text278').onClick(() =>  {
        $w('#statebox14').changeState("state12")
    })


    $w('#text287').onClick(() =>  {
        $w('#statebox15').changeState("state13")
    })

    $w('#text283').onClick(() =>  {
        $w('#statebox15').changeState("state14")
    })


    $w('#text303').onClick(() =>  {
        $w('#statebox18').changeState("state19")
    })

    $w('#text298').onClick(() =>  {
        $w('#statebox18').changeState("state20")
    })


    $w('#text297').onClick(() =>  {
        $w('#statebox17').changeState("state17")
    })

    $w('#text293').onClick(() =>  {
        $w('#statebox17').changeState("state18")
    })


    $w('#text292').onClick(() =>  {
        $w('#statebox16').changeState("state15")
    })

    $w('#text288').onClick(() =>  {
        $w('#statebox16').changeState("stat16")
    })

});